import { useEffect } from 'react'

/** Keeps the app layout aligned with mobile browser chrome and keyboard changes. */
export function useViewportHeight(): void {
  useEffect(() => {
    const updateViewportHeight = () => {
      const visualHeight = window.visualViewport?.height || window.innerHeight
      document.documentElement.style.setProperty('--app-height', `${Math.round(visualHeight)}px`)
    }

    updateViewportHeight()
    window.addEventListener('resize', updateViewportHeight)
    window.visualViewport?.addEventListener('resize', updateViewportHeight)
    window.visualViewport?.addEventListener('scroll', updateViewportHeight)
    return () => {
      window.removeEventListener('resize', updateViewportHeight)
      window.visualViewport?.removeEventListener('resize', updateViewportHeight)
      window.visualViewport?.removeEventListener('scroll', updateViewportHeight)
    }
  }, [])
}
